export default () => {
  return {
    user: {
      emailAddress: `andrw.tmplton${Math.floor(Math.random() * 1000 * 1000 * 1000)}@gmail.com`,
      firstName: 'Andrew',
      lastName: 'Templeton',
      phoneNumber: '5123508228',
      address: {
        street: '710 Colorado St. #2H',
        city: 'Austin',
        state: 'TX',
        zip: '78701'
      }
    },
    car: {
      vin: 'WDDGF4HBXEA966339',
      milesPerYear: 7000,
      odometer: 32000,
      yearsToOwn: 5,
      flags: {
        commercialUse: false,
        certifiedPreowned: true,
        secondOwner: true,
        hasLiftKitOrOversizeTires: false,
        modifiedVehicle: false,
        isSalvageTitle: false
      }
    }
  }
}
